<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-card-title class="px-0">
      Proxers
    </v-card-title>
    <proxers />
  </v-container>
</template>

<script>
  import Proxers from '@/modules/proxers/components/Proxers.vue'

  export default {
    components: {
      Proxers
    }
  }
</script>
